<div class="container mt-5">
  @if (authDocumentInfo) {
  <h2>Odbacivanje ovlaštenja</h2>
  <p>Identifikator dokumenta: {{ authDocumentInfo.AuthDocumentId }}</p>
  <p>
    Poslovni subjekt:
    {{ authDocumentInfo.FromPersonLegal?.EntityName }}
    {{ authDocumentInfo.FromPersonLegal?.KeyDisplay }}
  </p>
  <div class="bg-danger-light text-danger">
    <form nz-form (ngSubmit)="rejectAuthorizationDocument()" [formGroup]="rejectAuthorizationDocumentForm">
      <strong class="ml-3">Odbacivanje ovlaštenja</strong>

      <div nz-row style="height: 10em">
        <div nz-col nzSpan="6"></div>

        <div nz-col nzSpan="12">
          <nz-form-item>
            <textarea placeholder="Unesite razlog odbacivanja" style="width: 100%; height: 7em" class="m-3"
              formControlName="rejectReason"></textarea>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="6"></div>
      </div>

      <div nz-row>
        <div nz-col nzSpan="8"></div>
        <div nz-col nzSpan="8">
          <div class="d-flex justify-content-center gap-2">
            <button nz-button nzType="primary" class="btn btn-primary" type="submit"
              [disabled]="rejectAuthorizationDocumentForm.invalid"
              [attr.aria-disabled]="rejectAuthorizationDocumentForm.invalid ? true : false">
              <nz-icon nzType="like" nzTheme="outline" />
              Potvrdi
            </button>

            <button nz-button type="button" (click)="cancelReject($event)" nzType="primary" class="btn ml-3 btn-primary">
              <nz-icon nzType="close" nzTheme="outline" />
              Odustani
            </button>

          </div>
        </div>
        <div nz-col nzSpan="8"></div>
      </div>

    </form>

  </div>
  }
</div>